import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const IncentiveCCAStatement = () => {


  const dispatch = useDispatch();
  useEffect(() => {
    fetchOfferReport();
    dispatch(updateNavbarHeading("Incentive and CCA Statement"));
  }, []);


  const [searchTerm, setSearchTerm] = useState("");
  const [offerReport, setOfferReport] = useState([]);
  const [typeOptList, setTypeOptList] = useState([]);
  const [empOptList, setEmpOptList] = useState([]);
  const [projectOptList, setProjectOptList] = useState([]);
  const [CitiesOptList, setCitiesOptList] = useState([]);
  const getFormattedDate = (date) => {
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  const today = new Date();
  const sameDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

  const [filterFormData, setFilterData] = useState([
    {
      label: "From Date",
      value: moment(sameDayPrevMonth).format("DD-MMM-YYYY"), // Same day of the previous month
    },
    {
      label: "To Date",
      value: moment(today).format("DD-MMM-YYYY"), // Current date
    },
  ]);
  const [statusOptList, setStatusOptList] = useState([]);
  const [payrollMonthList, setPayrollMonthList] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [respStatus, setRepStatus] = useState(0);



  const columns = {
    Type: { text: "Type", visible: true },
    Employee: { text: "Employee", visible: true },
    Project: { text: "Project", visible: true },
    InvoiceNo: { text: "Invoice No", align: "end", visible: true },
    City: { text: "City", visible: false },
    Amount: { text: "Amount", align: "end", visible: true },
    PayrollMonth: { text: "Payroll Month", align: "center", visible: true },
    CreatedDate: { text: "Applied Date", align: "center", visible: false },
    ActionByName: { text: "Action By", visible: true },
    ApplicationStatus: { text: "Status", align: "start", visible: true },
    ActionDate: { text: "Action Date", align: "center", visible: false },
    ActionRemarks: { text: "Remark", visible: true },
  };

  const formDatas = [
    { name: "Type", type: "Select", options: [...typeOptList] },
    { name: "Employee", type: "Select", options: [...empOptList] },
    { name: "Project", type: "Select", options: [...projectOptList] },
    { name: "City", type: "Select", options: [...CitiesOptList] },
    { name: "Status", type: "Select", options: [...statusOptList] },

    {
      name: "From Date",
      type: "Date",
      //  options: [...payrollMonthList]
    },
    {
      name: "To Date",
      type: "Date",
      //  options: [...payrollMonthList]
    },
    { name: "Payroll Month", type: "IsMulti", options: [...payrollMonthList] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchOfferReport = async () => {

    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/7?P_Type=${0}&P_EmployeeID=${0}&P_ProjectID=${0}&P_CityID=${""}&SearchString=${""}&P_ApplicationStatus=${""}&P_FromDate=${moment(sameDayPrevMonth).format("YYYY-MM-DD")}&P_ToDate=${moment(today).format("YYYY-MM-DD")}`
      );
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        const data = response?.data?.data?.data;
        setOfferReport(data);

        // type List
        const typeList = response?.data?.data?.typeList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setTypeOptList(typeList);
        //   Employee List
        const empList = response?.data?.data?.employeeList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmpOptList(empList);
        //   Project List
        const projectList = response?.data?.data?.projectList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjectOptList(projectList);

        //   city List
        const cityList = response?.data?.data?.citiesList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setCitiesOptList(cityList);

        //   status List
        const filteredStatus = response?.data?.data?.filteredStatus;
        const statusList = Object.values(filteredStatus).map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatusOptList(statusList);

        //   payroll Month List
        const payrollList = response?.data?.data?.months
          .map((tech) => ({
            value: tech.value,
            label: tech.text,
          }))
          .reverse();
        setPayrollMonthList(payrollList);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  const handleGetData = async () => {
    const type = filterFormData.find(o => o.label === "Type")?.value || 0;
    const empID = filterFormData.find(o => o.label === "Employee")?.value || 0;
    const projectID = filterFormData.find(o => o.label === "Project")?.value || 0;
    const cityID = filterFormData.find((o) => o.label === "City")?.value || "";
    const monthID = filterFormData.find((o) => o.label === "Payroll Month")?.value || "";
    const stausID = filterFormData.find((o) => o.label === "Status")?.value || "";
    const fromDate = moment(filterFormData.find((o) => o.label === "From Date")?.value).format("YYYY-MM-DD")
    const toDate = moment(filterFormData.find((o) => o.label === "To Date")?.value).format("YYYY-MM-DD")

    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/7?P_Type=${type}&P_EmployeeID=${empID}&P_ProjectID=${projectID}&P_CityID=${cityID}&SearchString=${monthID}&P_ApplicationStatus=${stausID}&P_FromDate=${fromDate}&P_ToDate=${toDate}`
      );
      SetApiStatus(response?.status);
      const data = response?.data?.data?.data;
      setOfferReport(data);

      // type List
      const typeList = response?.data?.data?.typeList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setTypeOptList(typeList);
      //   Employee List
      const empList = response?.data?.data?.employeeList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setEmpOptList(empList);
      //   Project List
      const projectList = response?.data?.data?.projectList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setProjectOptList(projectList);

      //   city List
      const cityList = response?.data?.data?.citiesList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setCitiesOptList(cityList);

      //   status List
      const filteredStatus = response?.data?.data?.filteredStatus;
      const statusList = Object.values(filteredStatus).map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setStatusOptList(statusList);

      //   payroll Month List
      const payrollList = response?.data?.data?.months
        .map((tech) => ({
          value: tech.value,
          label: tech.text,
        }))
        .reverse();
      setPayrollMonthList(payrollList);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleReset = () => {
    const resetFilter = [
      {
        label: "From Date",
        value: moment(sameDayPrevMonth).format("DD-MMM-YYYY"),
      },
      {
        label: "To Date",
        value: moment(today).format("DD-MMM-YYYY"),
      },
    ];

    setFilterData(resetFilter);
    setSearchTerm(""); // Also clear the search term if needed

    fetchOfferReport();

  };


  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              responseStatus={respStatus}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleReset={handleReset}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default IncentiveCCAStatement;
